module.exports = __webpack_public_path__ + "static/media/project-image-4-big.4f51a944.png";